import { clearSection }                                                                              from "dmpconnectjsapp-base/actions";
import commands, { mssSubTypes }                                                                     from "dmpconnectjsapp-base/actions/config/commands";
import { apiSections, mssLoginTypes, mssReceiptNotificationTypes }                                   from "dmpconnectjsapp-base/constants";
import { getActiveMssAccountConfig, getApiType, getDefaultMssConfig, getMssAccounts, getMssReplyTo } from "dmpconnectjsapp-base/helpers/accessors";
import { authenticationTypes, getAccessRightsProps }                                                 from "dmpconnectjsapp-base/rules/accessRights";
import PropTypes                                                                                     from "prop-types";
import React                                                                                         from "react";
import { Button, Form, Row }                                                                         from "react-bootstrap";
import { connect }                                                                                   from "react-redux";
import { deleteMssAccount, getAction, setModalConfirmation, setUserPreferences }                     from "../../dmpconnect/actions";
import { isMssActive }                                                                               from "../../dmpconnect/helpers";
import { closeConfirmModal }                                                                         from "../../dmpconnect/helpers/documentUtils";
import { getDefaultMssAccountLabel }                                                                 from "../../dmpconnect/helpers/mss";
import SwitchCheckbox                                                                                from "../Common/Form/Input/SwitchCheckbox";
import Alert                                                                                         from "../Common/Message/Alert";
import MssAccountSelector                                                                            from "./MssAccountSelector";
import MssAutoConfigForm                                                                             from "./MssAutoConfigForm";
import MssConfig                                                                                     from "./MssConfig";
import MssOTPLogin                                                                                   from "./MssOTPLogin";

function MssConfiguration ({
  dispatch,
  columnLayout,
  mssActive,
  config,
  title,
  login,
  otpLogin,
  mssAccounts,
  mssDefaultConfig,
  psId,
  mssActiveAccount,
  authenticationType
}) {
  if (otpLogin) {
    return <MssOTPLogin />;
  }
  
  const [openDetails, setOpenDetails]                                         = React.useState(false);
  const [enabled, setEnabled]                                                 = React.useState(mssActive);
  const [addingAccount, setAddingAccount]                                     = React.useState(false);
  const [addingAccountAutoConfig, setAddingAccountAutoConfig]                 = React.useState(false);
  const [addingAccountMailizCpx, setAddingAccountMailizCpx]                   = React.useState(false);
  const [previousAddingAccountAutoConfig, setPreviousAddingAccountAutoConfig] = React.useState(false);
  const [previousAddingAccountMailizCpx, setPreviousAddingAccountMailizCpx]   = React.useState(false);
  
  React.useEffect(() => {
    dispatch(clearSection(apiSections.MSS_GET_FOLDERS));
    dispatch(clearSection(apiSections.MSS_SEND_SMTP_EMAIL));
    
    if (!config && authenticationType !== authenticationTypes.DIRECT) {
      setAddingAccountAutoConfig(true);
    }
    
    return () => {
      dispatch(clearSection(apiSections.MSS_GET_FOLDERS));
      dispatch(clearSection(apiSections.MSS_SEND_SMTP_EMAIL));
    };
  }, []);
  
  const cpxAvailable = React.useMemo(() => {
    const direct            = authenticationType === authenticationTypes.DIRECT;
    const operatorCpxExists = (mssDefaultConfig.mssOperatorsConfig || []).some(op => op.loginType === mssLoginTypes.CPX && op.api === mssSubTypes.IMAP);
    
    return direct && operatorCpxExists;
  }, []);
  
  const submitMss = () => {
    dispatch(setUserPreferences({ mssActive: enabled }));
  };
  
  const confirmDeleteMessage = React.useCallback(() => {
    dispatch(setModalConfirmation({
      show                : true,
      title               : "Supprimer un compte MSS",
      message             : (
        <>
          Confirmez vous la suppression du compte
          <br />
          {getDefaultMssAccountLabel(mssActiveAccount, mssAccounts, mssDefaultConfig.mssOperatorsConfig)}
          <br />
          ?
        </>
      ),
      confirmButtonText   : "Oui, supprimer",
      confirmButtonVariant: "danger",
      cancelButtonText    : "Annuler",
      handleConfirm       : () => {
        dispatch(deleteMssAccount(psId, mssActiveAccount));
        dispatch(clearSection(apiSections.MSS_GET_FOLDERS));
        dispatch(clearSection(apiSections.MSS_SEND_SMTP_EMAIL));
        closeConfirmModal(dispatch);
      }
    }));
  }, [psId, mssActiveAccount]);
  
  return (
    <>
      <div className="d-flex justify-content-between align-items-start w-full">
        <div className="flex-grow-1">
          {title && (
            <h5 className="mb-4">{title}</h5>
          )}
          
          {!login && (
            <>
              <Form.Group as={columnLayout ? Row : undefined}>
                <Form.Label column={columnLayout} sm="4">
                  Activer MSS
                </Form.Label>
                <div className={`d-flex v-centered ${columnLayout ? "col-sm-8" : undefined}`}>
                  <SwitchCheckbox
                    id="mssActive"
                    onChange={(event) => {
                      setEnabled(event.target.checked);
                      dispatch(setUserPreferences({ mssActive: event.target.checked }));
                    }}
                    name="mssActive"
                    checked={enabled}
                    showLabel
                    onLabel="Activé"
                    offLabel="Désactivé"
                  />
                </div>
              </Form.Group>
              <div className="admin-content-divider" />
            </>
          )}
          
          <h5>Gestion des comptes</h5>
          {!addingAccount && !addingAccountAutoConfig && mssAccounts.length > 0 && (
            <Form.Group>
              <Form.Label>Choix du compte</Form.Label>
              <MssAccountSelector disabled={addingAccount || addingAccountAutoConfig} />
            </Form.Group>
          )}
          {(addingAccount || addingAccountAutoConfig)
            ? (
              <Alert type="info" className="align-items-center">
                <div className="d-flex align-items-center justify-content-between">
                  <span>Création d'un nouveau compte</span>
                  <div className="d-flex flex-row align-items-center">
                    <div className="btn-group-toggle">
                      <Button
                        size="sm"
                        className={`toggle-button mr-3 ${addingAccount && openDetails ? "active" : ""}`}
                        onClick={() => {
                          if (addingAccount && openDetails) {
                            setAddingAccount(previousAddingAccountMailizCpx);
                            setOpenDetails(false);
                            setAddingAccountAutoConfig(previousAddingAccountAutoConfig);
                            setAddingAccountMailizCpx(previousAddingAccountMailizCpx);
                            setPreviousAddingAccountAutoConfig(false);
                            setPreviousAddingAccountMailizCpx(false);
                          } else {
                            setAddingAccount(true);
                            setOpenDetails(true);
                            setPreviousAddingAccountAutoConfig(addingAccountAutoConfig);
                            setPreviousAddingAccountMailizCpx(addingAccountMailizCpx);
                            setAddingAccountAutoConfig(false);
                            setAddingAccountMailizCpx(false);
                          }
                        }}
                      >
                        Configuration avancée
                      </Button>
                    </div>
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={() => {
                        setAddingAccount(false);
                        setAddingAccountAutoConfig(false);
                        setAddingAccountMailizCpx(false);
                      }}
                    >
                      Annuler
                    </Button>
                  </div>
                </div>
              </Alert>
            )
            : (
              <div className="container-list vertical">
                {mssDefaultConfig.enableAutoConfig ? (
                  <>
                    <Button
                      size="sm"
                      variant="success"
                      onClick={() => {
                        setAddingAccountAutoConfig(true);
                        setAddingAccount(false);
                        setAddingAccountMailizCpx(false);
                        dispatch(clearSection(apiSections.MSS_GET_FOLDERS));
                        dispatch(clearSection(apiSections.MSS_SEND_SMTP_EMAIL));
                      }}
                    >
                      <i className="ic-add-white" />
                      {`Ajouter un compte${cpxAvailable ? " (authentification PSC)" : ""}`}
                    </Button>
                    {cpxAvailable && (
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={() => {
                          dispatch(getAction(
                            commands.getEmailAdress,
                            apiSections.MSS_GET_EMAIL,
                            psId,
                            { silentError: true }
                          ));
                          setAddingAccountAutoConfig(false);
                          setAddingAccountMailizCpx(true);
                          setAddingAccount(true);
                          dispatch(clearSection(apiSections.MSS_GET_FOLDERS));
                          dispatch(clearSection(apiSections.MSS_SEND_SMTP_EMAIL));
                        }}
                      >
                        <i className="ic-add-white" />
                        Ajouter un compte (Mailiz authentification CPX)
                      </Button>
                    )}
                  </>
                ) : (
                  <Button
                    size="sm"
                    variant="primary"
                    onClick={() => {
                      setAddingAccountAutoConfig(false);
                      setAddingAccountMailizCpx(false);
                      setAddingAccount(true);
                      dispatch(clearSection(apiSections.MSS_GET_FOLDERS));
                      dispatch(clearSection(apiSections.MSS_SEND_SMTP_EMAIL));
                    }}
                  >
                    <i className="ic-add-white" />
                    Ajouter un compte
                  </Button>
                )}
                {mssAccounts.length > 0 && (
                  <Button
                    size="sm"
                    variant="danger"
                    onClick={() => confirmDeleteMessage()}
                  >
                    <i className="ic-delete" />
                    Supprimer ce compte
                  </Button>
                )}
              </div>
            )
          }
 
          <Form className="flex-grow-1 mr-5 mt-3">
            
            {!addingAccountAutoConfig && (mssAccounts.length > 0 || addingAccount) && (
              <>
                <h6
                  className={`pointer has-arrow after on-border mt-3 ${openDetails ? "active" : "mb-0"}`}
                  onClick={() => setOpenDetails(!openDetails)}
                >
                  Configuration de l&apos;accès MSS
                </h6>
                <MssConfig
                  openDetails={openDetails}
                  key={addingAccount ? "new" : mssActiveAccount.id}
                  columnLayout={columnLayout}
                  config={config || addingAccount}
                  mssActive={enabled}
                  onSubmit={() => submitMss()}
                  onEnd={() => setAddingAccount(false)}
                  mssDefaultConfig={mssDefaultConfig}
                  mssAccounts={mssAccounts}
                  mssAccount={addingAccount ? {
                    mssOperator: addingAccountMailizCpx
                      ? ((mssDefaultConfig.mssOperatorsConfig || []).find(op => op.loginType === mssLoginTypes.CPX && op.api === mssSubTypes.IMAP) || {}).id
                      : undefined
                  } : mssActiveAccount}
                />
              </>
            )}
            {addingAccountAutoConfig && (
              <MssAutoConfigForm callback={() => setAddingAccountAutoConfig(false)} />
            )}
          </Form>
        </div>
        <i className="ic-mss" />
      </div>
    </>
  );
}

MssConfiguration.propTypes    = {
  dispatch        : PropTypes.func.isRequired,
  columnLayout    : PropTypes.bool,
  mssActive       : PropTypes.bool,
  config          : PropTypes.bool,
  login           : PropTypes.bool,
  otpLogin        : PropTypes.bool,
  title           : PropTypes.string,
  connectorApiType: PropTypes.string.isRequired,
  mssAccounts     : PropTypes.array,
  mssDefaultConfig: PropTypes.object.isRequired,
  mssActiveAccount: PropTypes.object
};
MssConfiguration.defaultProps = {
  columnLayout              : true,
  mssActive                 : false,
  config                    : true,
  login                     : false,
  otpLogin                  : false,
  title                     : "",
  mssReceiptNotificationType: mssReceiptNotificationTypes.DSN,
  mssAccounts               : [],
  mssDefaultConfig          : {},
  mssActiveAccount          : {}
};

function mapStateToProps (state, props) {
  const mssDefaultConfig = getDefaultMssConfig(state);
  const { accessRights } = getAccessRightsProps(state);
  
  const mssActiveAccount = getActiveMssAccountConfig(state);
  
  return {
    psId                      : accessRights.psId,
    authenticationType        : accessRights.authenticationType,
    mssActive                 : isMssActive(state),
    mssReceiptNotificationType: mssDefaultConfig.mssReceiptNotificationType,
    mssReplyTo                : getMssReplyTo(state),
    otpLogin                  : mssActiveAccount.mssLoginType === mssLoginTypes.OTP && props.login === true,
    connectorApiType          : getApiType(state),
    mssAccounts               : getMssAccounts(state),
    mssActiveAccount,
    mssDefaultConfig
  };
}

export default connect(mapStateToProps)(MssConfiguration);
